import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './metaPixel';
initMetaPixel();
render(<App data-id="element-228" />, document.getElementById('root'));